<template>
  <Teleport to="body">
    <div class="c-app-overlay">
      <div class="inner__wrapper">
        <slot />
      </div>
      <div class="inner__mask fs" @click="handleMaskClick"></div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, useHostAppInstance } from '@zto/zpage'

const app = useHostAppInstance()

const emit = defineEmits('hide')

function handleMaskClick() {
  emit('hide')
}
</script>

<style lang="scss" scoped>
.c-app-overlay {
  position: fixed;
  z-index: calc(var(--el-index-normal) + 100);
  top: var(--app-header-height);
  left: 0;
  inset: var(--app-header-height) auto auto 0px;
  height: calc(100vh - var(--app-header-height));
  width: 100vw;
  margin: 0px;

  .inner__wrapper {
    position: absolute;
    z-index: 1;
    width: 100%;
  }

  .inner__mask {
    position: absolute;
    z-index: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
